import { useQuery } from 'react-apollo'
import { GetMe } from '../../../graphql/user/queries'
import { User } from '@labsavvyapp/components'

/**
 *  Query to get a current user (which includes active partner and project info)

 * @returns User
 */

export const useQueryGetMeApi = () => {
  const { data: userData, error: userDataError, loading: userDataLoading, refetch: refetchUserData } = useQuery(GetMe)

  return { data: userData as User, error: userDataError, loading: userDataLoading, refetch: refetchUserData }
}
